// 使用常量替代 Mutation 事件类型

// 是否需要图形验证码
export const SHOW_CAPTACH = 'SHOW_CAPTACH'

// 保存用户登录数据
export const SET_USER_INFO = 'SET_USER_INFO'

// 账户信息
export const GET_ACC_INFO = 'GET_ACC_INFO'